import React from 'react';

/**
 * Componente de input para contraseña con toggle de visibilidad
 *
 * @param {Object} props - Propiedades del componente
 * @param {string} props.label - Texto del label
 * @param {string} props.name - Nombre e id del input
 * @param {string} props.value - Valor del input
 * @param {Function} props.onChange - Handler de cambio
 * @param {string} [props.error] - Mensaje de error a mostrar
 * @param {string} [props.placeholder='********'] - Placeholder del input
 * @param {boolean} [props.disabled] - Si el input está deshabilitado
 * @param {boolean} props.showPassword - Si la contraseña es visible
 * @param {Function} props.onToggle - Handler para toggle de visibilidad
 * @returns {JSX.Element}
 */
function PasswordInput({
  label,
  name,
  value,
  onChange,
  error,
  placeholder = '********',
  disabled,
  showPassword,
  onToggle
}) {
  return (
    <div className="form-group">
      <label htmlFor={name} className="form-label">
        <i className="fas fa-lock"></i> {label}
      </label>
      <div className="input-group">
        <input
          type={showPassword ? 'text' : 'password'}
          id={name}
          name={name}
          className={`form-control ${error ? 'is-invalid' : ''}`}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          disabled={disabled}
        />
        <button
          type="button"
          className="btn-input-addon"
          onClick={onToggle}
          tabIndex="-1"
        >
          <i className={`fas fa-eye${showPassword ? '-slash' : ''}`}></i>
        </button>
      </div>
      {error && (
        <div className="invalid-feedback">
          <i className="fas fa-exclamation-circle"></i> {error}
        </div>
      )}
    </div>
  );
}

export default PasswordInput;
